import { PAGE_TITLE_CHECKOUT_EDITOR } from '#shared/lib/constants';
import { useExperimentFlag } from '#shared/lib/flags';
import { checkoutEditorRoute } from '#shared/lib/routes';
import { type MenuItem } from '../types';

const useShowCheckoutEditor = () => useExperimentFlag('enable_checkout_editor');

export const CHECKOUT_MENU_ITEM: MenuItem = {
    href: checkoutEditorRoute.getUrl(),
    itemId: 'checkout-editor',
    iconLabel: '',
    permission: 'settings',
    routes: [checkoutEditorRoute.route],
    label: PAGE_TITLE_CHECKOUT_EDITOR,
    title: PAGE_TITLE_CHECKOUT_EDITOR,
    useShow: useShowCheckoutEditor,
    isMobileSupported: true,
};
